import { useState } from "react";
import { Link } from "react-router-dom";
import { FilterSidebar } from "../sidebar/FilterSidebar.js";
import { CalendarDayIcon } from "../../lib/useDynamicFavicon.js";
import { useI18n } from "../../lib/useI18n.js";
import { MobileDrawer } from "./MobileDrawer.js";
import { useEdgeSwipe } from "./useEdgeSwipe.js";

/**
 * Mobile sidebar: an overlay drawer holding the brand + filter lists (nav lives
 * in the BottomNav; backup/restore moved to Settings → Data). Opened by dragging
 * a finger in from the LEFT screen edge; closed by scrim tap / swipe back /
 * Android back.
 */
export function MobileSidebar() {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  useEdgeSwipe("left", () => setOpen(true), !open);

  return (
    <MobileDrawer side="left" open={open} onClose={() => setOpen(false)} label={t("common.filters")}>
      <Link
        to="/today"
        className="mb-3 flex items-center gap-0.5 px-2 text-base font-semibold"
        onClick={() => setOpen(false)}
      >
        <span>the</span>
        <CalendarDayIcon size={28} />
        <span className="truncate">{t("common.calendar")}</span>
      </Link>
      <div className="min-h-0 flex-1 space-y-2 overflow-y-auto">
        <FilterSidebar />
      </div>
    </MobileDrawer>
  );
}
